// removed by extract-text-webpack-plugin
module.exports = {"topStoreOuterContainer":"topStoreOuterContainer__2GYzj","topStoreContainer":"topStoreContainer__3RAE7","merchantName":"merchantName__1BPhK","offersCardWrapper":"offersCardWrapper__1pEdt"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/topOffers/style.css
// module id = errh
// module chunks = 323